module.exports = __webpack_public_path__ + "static/sport/euro.1acc748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/euro.png
// module id = Z7Io
// module chunks = 0